export default "__VITE_ASSET__SMkDyleU__"